import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=02e3820c&scoped=true&"
import script from "./ProductList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ProductList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=02e3820c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e3820c",
  null
  
)

export default component.exports